import 'core-js/es/symbol';
import 'core-js/es/promise';
import YouTubePlayer from 'youtube-player';
import 'intersection-observer';
import {triggerEvent} from '../base/utils';

class VideoPlayer {
    constructor(videoElement) {
        this.$videoElement = videoElement;
        this.$videoContainer = this.$videoElement.closest('.video');

        this.init();
        this.events();
    }

    init() {
        this.videoId = this.$videoElement.dataset['id'];
        this.player = YouTubePlayer(this.$videoElement, {
            videoId: this.videoId,
            playerVars: {
                showinfo: 0,
                rel: 0,
                modestbranding: 1,
                playsinline: 1
            }
        });
        this.player.on('ready', () => {
            this.$playerElement = this.$videoContainer.querySelector('.video-player');
            this.$playerElement.setAttribute('tabindex', '-1');
        });

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    triggerEvent(document.body, 'video-pause', this.player);
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0
        });

        this.observer.observe(this.$videoContainer);
    }

    events() {
        this.player.on('stateChange', event => {
            if (event.data === YT.PlayerState.PLAYING || event.data === YT.PlayerState.BUFFERING) {
                triggerEvent(document.body, 'video-play', this.player);
            } else if (event.data === YT.PlayerState.ENDED) {
                this.player.seekTo(0);
                this.player.stopVideo();
                this.$videoContainer.classList.remove('playing');
                this.$videoContainer.classList.add('ended');
                this.$playerElement.setAttribute('tabindex', '-1');
            } else if (event.data === YT.PlayerState.CUED) {
                this.$videoContainer.classList.remove('playing');
                this.$videoContainer.classList.add('ended');
                this.$playerElement.setAttribute('tabindex', '-1');
            }
        });

        document.body.addEventListener('video-play', e => {
            let player = e.detail;

            this.$playerElement.setAttribute('tabindex', '0');
            this.$playerElement.focus();
            if (this.player === player) {
                this.$videoContainer.classList.remove('ended');
                this.$videoContainer.classList.add('playing');
            } else {
                this.player.pauseVideo();
            }
        });

        document.body.addEventListener('video-pause', e => {
            this.player.pauseVideo();
        });

        for (let $el of this.$videoContainer.querySelectorAll('.video-thumbnail, .video-play')) {
            $el.addEventListener('click', () => {
                triggerEvent(document.body, 'video-play', this.player);

                this.player.playVideo();
            });
        }
    }
}

export default VideoPlayer;
